module.exports = __webpack_public_path__ + "static/media/google_meet_dial_in.a3dc12c9.png";